import { ReactNode, useEffect } from "react";
import { useWorkspace, useUserPermissions, useUser } from "@/hooks";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";
import WorkspaceEmpty from "./Workspace.empty";
import WorkSpaceError from "./Workspace.error";
import { requestContext } from "@/infrastructure/services/logger";

const WorkspaceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading, error, setWorkspace, hasWorkspace, workspace } = useWorkspace();
  const { user } = useUser();
  const { setPermissions } = useUserPermissions();

  useEffect(() => {
    setWorkspace();
    setPermissions();
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <WorkSpaceError />;
  }

  if (!hasWorkspace) {
    return <WorkspaceEmpty />;
  }

  /** Set Logger Context */
  requestContext.run({
    user: { email: user?.email, username: user?.fullName },
    brand: workspace?.workspaceKey,
  });

  return children;
};

export default WorkspaceProvider;
